/// <amd-module name="SuiteCommerce.CookieConsent.Common.CookiesLogger"/>
define("SuiteCommerce.CookieConsent.Common.CookiesLogger", ["require", "exports", "SuiteCommerce.CookieConsent.CookiesHandler"], function (require, exports, CookiesHandler_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CookiesLogger = void 0;
    var COOKIE_CONSENT_LOGGER_ACTION_NAME = 'Accept Privacy Consent';
    var CookiesLogger = /** @class */ (function () {
        function CookiesLogger() {
            this.NLRUM = window.NLRUM && window.NLRUM.actionStart && window.NLRUM.actionEnd ? window.NLRUM : null;
        }
        CookiesLogger.prototype.startAction = function () {
            if (this.NLRUM) {
                var actionId = this.NLRUM.actionStart(COOKIE_CONSENT_LOGGER_ACTION_NAME);
                this.actionId = actionId;
            }
        };
        CookiesLogger.prototype.endAction = function () {
            if (this.NLRUM && this.actionId) {
                this.NLRUM.actionEnd(this.actionId, this.getCookieLog());
            }
        };
        CookiesLogger.prototype.getCookieLog = function () {
            return {
                siteUrl: window.location.hostname,
                shopperAnalyticsConsent: this.getCookieOptions()
            };
        };
        CookiesLogger.prototype.getCookieOptions = function () {
            var decodedCookie = CookiesHandler_1.CookiesHandler.getDecodedCookies();
            if (decodedCookie) {
                return {
                    id: decodedCookie.id,
                    timestamp: decodedCookie.timestamp,
                    consentSettings: this.formatCookieOptions(decodedCookie.consentSettings)
                };
            }
            return null;
        };
        CookiesLogger.prototype.formatCookieOptions = function (cookieOptions) {
            var options = [];
            Object.keys(cookieOptions).forEach(function (option) {
                options.push(option + '|' + (cookieOptions[option] ? 'T' : 'F'));
            });
            return options.join(',');
        };
        return CookiesLogger;
    }());
    exports.CookiesLogger = CookiesLogger;
});
